/**
 * MGT PDP Symptom Quiz
 * Steps through symptom questions, tallies "yes" answers, and renders the
 * matching gene panel on the results screen.
 * Binds to every [data-mgt-quiz] root; config comes from a
 * <script type="application/json" data-mgt-quiz-config> inside the root.
 */
function geneArray(g) {
  return (g || '')
    .split(',')
    .map((x) => x.trim())
    .filter(Boolean);
}

function initQuizInstance(root) {
  const sectionEl = root.closest('[data-mgt-quiz-section]') || root;
  const configEl = root.querySelector('[data-mgt-quiz-config]');
  let steps = [];
  try {
    steps = JSON.parse(configEl.textContent);
  } catch (e) {
    steps = [];
  }

  const scrollTarget = root.getAttribute('data-mgt-scroll-target') || 'buy';
  let idx = 0;
  let answers = [];

  const screens = {
    intro: root.querySelector('[data-mgt-screen="intro"]'),
    question: root.querySelector('[data-mgt-screen="question"]'),
    results: root.querySelector('[data-mgt-screen="results"]'),
    noyes: root.querySelector('[data-mgt-screen="noyes"]'),
  };
  const qNameEl = root.querySelector('[data-mgt-qname]');
  const qTextEl = root.querySelector('[data-mgt-question]');
  const stepLabelEl = root.querySelector('[data-mgt-steplabel]');
  const fillEl = root.querySelector('[data-mgt-fill]');
  const backEl = root.querySelector('[data-mgt-back]');
  const countEl = root.querySelector('[data-mgt-count]');
  const geneListEl = root.querySelector('[data-mgt-genelist]');
  const resultsNote = root.querySelector('[data-mgt-results-note]');

  function show(name) {
    Object.keys(screens).forEach((k) => {
      if (screens[k]) screens[k].hidden = k !== name;
    });
    if (resultsNote) resultsNote.hidden = !(name === 'results' || name === 'noyes');
    if (sectionEl) sectionEl.classList.toggle('mq-started', name !== 'intro');
  }

  function renderQuestion() {
    const step = steps[idx];
    if (!step) return finish();
    if (qNameEl) qNameEl.textContent = step.symptom || '';
    if (qTextEl) qTextEl.textContent = step.question || '';
    if (stepLabelEl) stepLabelEl.textContent = `${idx + 1} / ${steps.length}`;
    if (fillEl) fillEl.style.width = `${Math.round((idx / steps.length) * 100)}%`;
    if (backEl) backEl.hidden = idx === 0;
    show('question');
  }

  function finish() {
    const yes = [];
    answers.forEach((v, i) => {
      if (v === true) yes.push(steps[i]);
    });
    if (yes.length === 0) {
      show('noyes');
      return;
    }

    const uniq = [];
    yes.forEach((s) => {
      geneArray(s.genes).forEach((x) => {
        if (uniq.indexOf(x) === -1) uniq.push(x);
      });
    });
    if (countEl) countEl.textContent = uniq.length;

    if (geneListEl) {
      geneListEl.innerHTML = '';
      yes.forEach((s) => {
        const card = document.createElement('div');
        card.className = 'mq-card';
        const name = document.createElement('div');
        name.className = 'mq-card__name';
        name.textContent = s.symptom || '';
        card.appendChild(name);
        if (s.pathway) {
          const p = document.createElement('div');
          p.className = 'mq-card__path';
          p.textContent = s.pathway;
          card.appendChild(p);
        }
        const snps = document.createElement('div');
        snps.className = 'mq-snps';
        geneArray(s.genes).forEach((x) => {
          const sp = document.createElement('span');
          sp.className = 'mq-snp';
          sp.textContent = x;
          snps.appendChild(sp);
        });
        card.appendChild(snps);
        geneListEl.appendChild(card);
      });
    }
    show('results');
  }

  const startBtn = root.querySelector('[data-mgt-start]');
  if (startBtn) {
    startBtn.addEventListener('click', () => {
      idx = 0;
      answers = [];
      renderQuestion();
    });
  }

  root.querySelectorAll('[data-mgt-answer]').forEach((btn) => {
    btn.addEventListener('click', () => {
      answers[idx] = btn.getAttribute('data-mgt-answer') === 'yes';
      idx++;
      if (idx >= steps.length) finish();
      else renderQuestion();
    });
  });

  if (backEl) {
    backEl.addEventListener('click', () => {
      if (idx > 0) {
        idx--;
        renderQuestion();
      }
    });
  }

  root.querySelectorAll('[data-mgt-restart]').forEach((b) => {
    b.addEventListener('click', () => {
      idx = 0;
      answers = [];
      show('intro');
    });
  });

  root.querySelectorAll('[data-mgt-order]').forEach((b) => {
    b.addEventListener('click', () => {
      const target = document.getElementById(scrollTarget);
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
}

export default function initMgtQuiz() {
  document.querySelectorAll('[data-mgt-quiz]').forEach(initQuizInstance);
}
